import * as types from './types';
import { DELETE_LEAD_SUCCESS } from '../types';

const initialState = {};

export default (state = initialState, action) => {
  const { type, payload } = action || {};

  switch(type) {
    case types.ADD_CUSTOM_FORM_FIELD_DATA: {
      const { id: leadId, data } = payload || {};
      if (!leadId || !data) return state;
      return {
        ...state,
        [leadId]: data,
      };
    }

    case DELETE_LEAD_SUCCESS: {
      const { deleteId } = payload || {};
      if (!deleteId) return state;
      // eslint-disable-next-line no-unused-vars
      const { [deleteId]: _, ...newState } = state;
      return newState;
    }
    default:
      return state;
  }
};
